import React from 'react';
import { Typography, Box } from '@mui/material';

interface PageProps {
  title: string;
}

const PageStub: React.FC<PageProps> = ({ title }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This page is under construction.
      </Typography>
    </Box>
  );
};

export default PageStub;
